import { LngLatBounds } from 'mapbox-gl';
import { MRT_ColumnFiltersState } from 'mantine-react-table';

import { GesStatusStat } from './results-stats';

import { Filters } from '@data-access';

export const GES_STATUS_FILTER_ID = 'ges_status';

export const DEFAULT_RESULTS_CLAUSE = 'new' as const;

export const DEFAULT_RESULTS_COLUMN_FILTERS: MRT_ColumnFiltersState = [
  { id: 'clause', value: DEFAULT_RESULTS_CLAUSE },
];

export function buildResultsListFilters(
  page: number,
  sorting: Filters['sorting'],
  filters: MRT_ColumnFiltersState,
): Filters {
  return { page, sorting, filters };
}

export function serializeResultsQueryFilters(filters: Filters) {
  return {
    page: filters.page,
    sorting: filters.sorting,
    filters: filters.filters,
  };
}

/** Stable React Query key for map requests (LngLatBounds is not JSON-safe). */
export function serializeResultsMapQueryKey(params: {
  bounds: LngLatBounds;
  cluster: boolean;
  zoom: number;
  tableFilters?: Filters;
}) {
  const tableFilters = params.tableFilters ?? {
    page: 1,
    sorting: [],
    filters: [],
  };

  return {
    bbox: params.bounds
      .toArray()
      .flat()
      .map((coordinate) => Number(coordinate.toFixed(6))),
    cluster: params.cluster,
    zoom: Number(params.zoom.toFixed(2)),
    ...serializeResultsQueryFilters(tableFilters),
  };
}

export function getActiveGesStatuses(
  filters: MRT_ColumnFiltersState,
): Set<GesStatusStat> {
  const raw = filters.find((f) => f.id === GES_STATUS_FILTER_ID)?.value;
  if (raw == null || raw === '') return new Set();

  const values = Array.isArray(raw) ? raw : [raw];
  const parsed = values
    .map((v) => (typeof v === 'string' ? Number(v) : v))
    .filter((v): v is GesStatusStat => Number.isInteger(v) && v >= 0 && v <= 3);

  return new Set(parsed);
}
